export const petsKindPage = {
    petsKindPageAddPetButtonDesktop: {
        rbmail: {
            type: 'click',
            id: '42707720',
        },
    },
    petsKindPageAddPetButtonTouch: {
        rbmail: {
            type: 'click',
            id: '42707797',
        },
    },
    petsKindPageAskButtonDesktop: {
        rbmail: {
            type: 'click',
            id: '42707723',
        },
    },
    petsKindPageAskButtonTouch: {
        rbmail: {
            type: 'click',
            id: '42707801',
        },
    },
};
